import { useEffect, useRef } from 'react';
import { useAuth } from './useAuth';
import api from '../services/api';

const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes
const HEARTBEAT_INTERVAL = 30 * 1000; // 30 seconds

export const useActivityMonitor = () => {
  const { logout, token, refreshPermissions } = useAuth();
  const lastActivityRef = useRef(Date.now());
  const heartbeatIntervalRef = useRef(null);
  const checkIntervalRef = useRef(null);

  const updateActivity = () => {
    lastActivityRef.current = Date.now();
  };

  const sendHeartbeat = async () => {
    if (!token) return;
    
    try {
      const res = await api.post('/heartbeat');
      if (res?.data?.permissions) {
        refreshPermissions(res.data.permissions);
      }
    } catch (error) {
      console.error('Heartbeat failed:', error);
    }
  };

  const checkInactivity = () => {
    const now = Date.now();
    const timeSinceLastActivity = now - lastActivityRef.current;

    if (timeSinceLastActivity >= INACTIVITY_TIMEOUT) {
      logout();
    }
  };

  useEffect(() => {
    if (!token) return;

    updateActivity();

    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, updateActivity));

    heartbeatIntervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
    checkIntervalRef.current = setInterval(checkInactivity, 10000); // Check every 10 seconds

    return () => {
      events.forEach(event => window.removeEventListener(event, updateActivity));
      if (heartbeatIntervalRef.current) clearInterval(heartbeatIntervalRef.current);
      if (checkIntervalRef.current) clearInterval(checkIntervalRef.current);
    };
  }, [token]);
};
